import React from 'react';
import './Sponsors.css';
import Background from "../assets/splash-bg.jpg";
import SponsorsImage from "../assets/sponsors.png";
import Footer from './Footer.tsx';

const Sponsors = () => {
  return (
    <div className="sponsors-container">
      {/* Header Section */}
      <div 
        className="sponsors-hero-section" 
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div className="sponsors-overlay"></div>
        <div className="sponsors-content">
          <div className="sponsors-title-section">
            <h1 className="sponsors-page-title">SPONSORS</h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Gratitude Section */}
        <div className="gratitude-section">
          <p className="gratitude-text">
            On behalf of the Voices of Virtue 2025 team, we extend our heartfelt gratitude to the blessed 
            communities of <strong>Tajweed Institute</strong>, <strong>Masjid At-Taqwa</strong>, and <strong>WAH Coffee</strong>.
          </p>
        </div>

        {/* Sponsors Logos */}
        <div className="sponsors-logos-section">
          <img 
            src={SponsorsImage} 
            alt="Sponsors: Tajweed Institute, Masjid At-Taqwa, and WAH Coffee" 
            className="sponsors-image"
          />
        </div>

        {/* Blessing Section */}
        <div className="blessing-section">
          <p className="blessing-text">
            Your support has been instrumental in making this gathering possible, and we ask Allah ﷻ to 
            bless you abundantly for your contributions.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Sponsors;